var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44444 0.667969H2V1.11241V12.3717C2 12.6171 2.19898 12.8161 2.44444 12.8161C2.6899 12.8161 2.88889 12.6171 2.88889 12.3717V1.55686H10.7407C10.9862 1.55686 11.1852 1.35787 11.1852 1.11241C11.1852 0.866953 10.9862 0.667969 10.7407 0.667969H2.44444ZM3.77778 2.44575H4.22222H12.5185C12.764 2.44575 12.963 2.64473 12.963 2.89019C12.963 3.13565 12.764 3.33464 12.5185 3.33464H4.66667V14.1495C4.66667 14.3949 4.46768 14.5939 4.22222 14.5939C3.97676 14.5939 3.77778 14.3949 3.77778 14.1495V2.89019V2.44575ZM5.70356 4.44576C5.70356 4.15939 5.93571 3.92724 6.22208 3.92724H13.4813C13.7677 3.92724 13.9999 4.15939 13.9999 4.44576V14.8161C13.9999 15.1025 13.7677 15.3346 13.4813 15.3346H6.22208C5.93571 15.3346 5.70356 15.1025 5.70356 14.8161V4.44576ZM11.9258 6.00131V12.7421H7.77763V6.00131H11.9258ZM6.7406 4.96427V14.2976H12.9628V4.96427H6.7406ZM11.4073 13.7791V13.2606H8.29615V13.7791H11.4073Z",
    fill: "#4D4E65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.b0dd804eb358ad51c107d451d16fe983.svg";
export { ForwardRef as ReactComponent };